import { createFileRoute } from '@tanstack/react-router';
import PartnerChat from '@/pages/partner-chat';

export const Route = createFileRoute('/_authenticated/partner-chat/$bookingId')({
  component: PartnerChat,
});

